import { gql } from "@apollo/client";

export const CALCULAR_Z_SCORES = gql`
  query CalcularZScores (
    $tallaEnMetros: Float!,
    $peso: Float!,
    $edad: Float!,
    $mes: Float!,
    $dia: Float!,
    $sexo: String!
  ) {
    calcularZScores (
      input: {
        tallaEnMetros: $tallaEnMetros
        peso: $peso
        edad: $edad
        mes: $mes
        dia: $dia
        sexo: $sexo
      }
    ){
      zTalla
      zPeso
      zIMC
      iMC
    }
}`;